<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        class="grid-col-1-2 grid-row-1-2"
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="input-block grid-col-1-3 grid-row-2-3">
        <label>
          Component Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.COMPONENT_LABEL"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.radio.label"
          name="componentLabel"
          required
        />
      </div>
      
      <div class="checkbox-block grid-row-2-3">
        <input
          type="checkbox"
          name="required"
          id="metadata-checkbox-1"
          class="checkbox-input"
          v-model="formData.radio.required"
        />
        <label for="metadata-checkbox-1">
          Required
          <tooltip :text="TOOLTIP_TEXT.REQUIRED"></tooltip>
        </label>
      </div>
      <div class="input-block grid-row-3-4">
        <label>
          Individual Shareholder Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.INDIVIDUAL_SHAREHOLDER_LABEL"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.radio.options[0].label"
          name="indShareholderLabel"
          required
        />
      </div>
      <div class="input-block grid-row-3-4">
        <label>
          Corporate Shareholder Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.CORPORATE_SHAREHOLDER_LABEL"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.radio.options[1].label"
          name="corpShareholderLabel"
          required
        />
      </div>
      <div class="input-block grid-col-1-3 grid-row-4-5">
        <label>
          Individual Shareholder Name Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.IND_SHAREHOLDER_NAME"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.text.ind.label"
          name="indHolderNmLabel"
          required
        />
      </div>
      <div class="checkbox-block grid-row-4-5">
        <input
          type="checkbox"
          name="required"
          id="metadata-checkbox-2"
          class="checkbox-input"
          v-model="formData.text.ind.required"
        />
        <label for="metadata-checkbox-2">
          Required
          <tooltip :text="TOOLTIP_TEXT.REQUIRED"></tooltip>
        </label>
      </div>
      <div class="input-block grid-col-1-3 grid-row-5-6">
        <label>
          Corporate Shareholder Company Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.CORP_SHAREHOLDER_COMP"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.text.corp.company.label"
          name="corpCompanyNmLabel"
          required
        />
      </div>
      <div class="checkbox-block grid-row-5-6">
        <input
          type="checkbox"
          name="required"
          id="metadata-checkbox-3"
          class="checkbox-input"
          v-model="formData.text.corp.company.required"
        />
        <label for="metadata-checkbox-3">
          Required
          <tooltip :text="TOOLTIP_TEXT.REQUIRED"></tooltip>
        </label>
      </div>
      <div class="input-block grid-col-1-3 grid-row-6-7">
        <label>
          Corporate Shareholder Representative Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.CORP_SHAREHOLDER_REP"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.text.corp.companyRep.label"
          name="corpRepNmLabel"
          required
        />
      </div>
      <div class="checkbox-block grid-row-6-7">
        <input
          type="checkbox"
          name="required"
          id="metadata-checkbox-4"
          class="checkbox-input"
          v-model="formData.text.corp.companyRep.required"
        />
        <label for="metadata-checkbox-4">
          Required
          <tooltip :text="TOOLTIP_TEXT.REQUIRED"></tooltip>
        </label>
      </div>
      
      <div class="grid-col-1-4 grid-row-7-8">
        <slot></slot>
      </div>
      <fieldset v-if="!simpleView" class="more-option grid-col-1-4 grid-row-8-9">
        <legend>
          More Options
        </legend>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";

export default {
  name: "PDICSModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.FIELDS,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("metadataSaved", this.formData);
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
    simpleView: function() {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
  },
  mounted() {
    this.insertIntoComponentModal();
  },
  methods: {
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "1 / 2";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.checkbox-block {
  align-self: center;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
}

.checkbox-input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.grid-row-4-6 {
  grid-row: 4 / 6;
}

.grid-row-5-6 {
  grid-row: 5 / 6;
}

.grid-row-6-7 {
  grid-row: 6 / 7;
}

.grid-row-7-8 {
  grid-row: 7 / 8;
}

.grid-row-8-9 {
  grid-row: 8 / 9;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>